import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Beneficiario } from '../models/beneficiary.model';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequirementService {

  private urlServer = environment.URL_API;

  constructor(private http: HttpClient, private session: SessionService) {}

  getRequirement(matricula: string, idOrgao: string,query: { [key: string]: string }): Observable<{  anexado: boolean }> {
    const token = this.session.token;
    const apiUrl = `${this.urlServer}/files/requerimento-anexado/matricula/${matricula}/orgao/${idOrgao}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.get<{ anexado: boolean }>(apiUrl, {
      headers,
      params: query
    });
  }

  getDocumentPdf(payload: any): Observable<Blob> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    });

    return this.http.post(`${this.urlServer}/pdf/requerimento`, payload, {
      headers,
      responseType: 'blob'
    });
  }

  getQuadroDiscriminativoPdf(payload: any): Observable<Blob> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    });

    return this.http.post(`${this.urlServer}/pdf/quadro-discriminativo`, payload, {
      headers,
      responseType: 'blob'
    });
  }

  sendDocumentPdf(tipo: string, arquivo: File, dados: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.session.token}`
    });

    const formData = new FormData();
    formData.append('file', arquivo);
    formData.append('idOrgao', dados.orgao.id);
    formData.append('matricula', dados.matricula);
    formData.append('tipoDocumento', tipo === 'Laudo' ? 'Laudo Pericial' : 'Requerimento de Reserva Remunerada');
    formData.append('idTipoDocumento', tipo === 'Laudo' ? '47' : '400');

    console.log('file', arquivo);
    console.log('idOrgao', dados.orgao.id);
    console.log('matricula', dados.matricula);
    console.log('tipoDocumento', 'Requerimento de Aposentadoria');

    return this.http.post(`${this.urlServer}/files/upload`, formData, {
      headers
    });
  }
}
